import { Button, Card, Flex, Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { AddPreferredAgentModal } from './AddPreferredAgent/AddPreferredAgentModal'
import { useState } from 'react'
import { defineMessages, useIntl } from 'react-intl'

interface AddAgentCardProps {
  clientId: string
}

export const MSG = defineMessages({
  addAgentCardTitle: {
    id: 'addAgentCardTitle',
    defaultMessage: 'Add a real estate agent to your team'
  },
  addAgentCardDescription: {
    id: 'addAgentCardDescription',
    defaultMessage: 'Adding a real estate agent lets you reach them directly while exploring Homebot.'
  },
  addAgentButton: {
    id: 'addAgentButton',
    defaultMessage: 'Add real estate agent'
  }
})

export const AddAgentCard = ({ clientId }: AddAgentCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const intl = useIntl()
  return (
    <>
      <Card
        display='flex'
        data-qa='AddAgentCard'
        justifyContent='left'
        flexDirection='column'
        alignItems='flex-start'
        textAlign='left'
        width='375px'
      >
        <Flex display='flex' flexDirection='column' alignItems='flex-start' p={4}>
          <Text size='lg' fontWeight='semibold' color='neutral.900'>
            {intl.formatMessage(MSG.addAgentCardTitle)}
          </Text>
          <Text color='neutral.700' size='sm' textAlign='left'>
            {intl.formatMessage(MSG.addAgentCardDescription)}
          </Text>
          <Button
            mt={4}
            colorScheme='primary'
            onClick={() => setIsModalOpen(true)}
            alignSelf='flex-start'
            tracking={{
              guid: 'vR2k9PwdXzNgkAAeKuyVBn',
              ui_context: 'Add agent card add agent',
              descriptor: 'Add agent button clicked'
            }}
          >
            <Icon name='plus-btb' mr={2} h='12px' w='12px' />
            {intl.formatMessage(MSG.addAgentButton)}
          </Button>
        </Flex>
      </Card>

      <AddPreferredAgentModal clientId={clientId} isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  )
}
